import Vue from 'vue'
import store from '@store'


Vue.prototype.$trans = function(payload, lang = null, fallback = '') {
    var multilingual = store.state.lang

    return multilingual.active
    ? _.get(payload, lang ? lang : multilingual.lang, fallback)
    : payload
}

Vue.prototype.$hasLang = function() {
    return (this.lang 
    || (this.field ? true : false) 
    || (_.has(this.value, 'fr') ? true : false))
    && !_.has(this.value, 'block')
}

Vue.prototype.$getValue = function(payload, default_value = '') {

    var multilingual = store.state.lang

    if(_.has(payload.value, 'block'))
    {
        return _.get(payload.value.data, payload.field, '')
    }

    if(
        !multilingual.active || 
        _.has(payload.value, 'block') ||
        !payload.$hasLang() && !_.has(payload.value, 'fr')
    ) {
        return payload.field
        ? _.get(payload.value, payload.field, '')
        : _.get(payload, 'value', '')
    }

    if(!_.isObject(payload.value))
        return payload.value

    return payload.field
    ? _.get(payload.value, multilingual.lang + '.' + payload.field, default_value)
    : _.get(payload.value, multilingual.lang, default_value)
    //: _.get(payload.value, multilingual.lang, payload.value)

}


Vue.prototype.$setValue = function(payload, input) {

    var multilingual = store.state.lang
    var value = _.cloneDeep(payload.value)
    var field = payload.field

    if(_.has(value, 'block'))
    {
        if(_.isArray(value.data)) {
            value.data = {}
        }

        return _.set(value, 'data.'+field, input)
    }

    if(
        !multilingual.active || 
        !payload.$hasLang() && !_.has(value, 'fr')
    ) {
        return field
        ? _.set(value, field, input)
        : input
    }

    if(!_.isObject(value)) {
        value = {}
    }

    // Lang field 
    field = field
    ? multilingual.lang + '.' + field
    : multilingual.lang;
   
    return _.set(value, field, input)
}



Vue.prototype.$setFieldValue = function(field, value) {

    var multilingual = store.state.lang

    return multilingual.active
    ? this.$set(field, multilingual.lang, value)
    : this.$set(field, value)
}